import orderBy from 'lodash-es/orderBy';

import tickerObserver from '../utils/ticker/ticker-observer';

import Base from './base';

const { location: { pathname } } = window;

class UnderlyingTable extends Base {
	set isLoading(loading) {
		this.el.classList.toggle('is-loading', loading);
	}

	constructor(el) {
		super(el);

		this.sortHeaders = this.queryAll('th.js-sorter', this.refs.table);

		this.on('change');
		this.on('click');
	}

	onChange(e) {
		const { target: { value: section } } = e;

		this.changeUnderlyings(section);
	}

	onClick(e) {
		const { target } = e;

		if (this.sortHeaders.includes(target)) {
			this.onSortHeaderClicked(target);
		}
	}

	onSortHeaderClicked(headerElement) {
		const { dataset: {
			sort: property,
			direction = 'desc',
		} } = headerElement;

		// no property to sort on
		if (!property) {
			return;
		}

		const newDirection = direction === 'asc'
			? 'desc'
			: 'asc';

		this.sortTable(property, newDirection);
		this.updateHeaders(headerElement, newDirection);
	}

	sortTable(property, direction) {
		const rows = this
			.queryAll('tr', this.refs.tableBody)
			.map(row => ({
				el: row,
				value: this.query(`td[data-${property}]`, row).dataset[property],
			}));

		const rowsSorted = orderBy(rows, 'value', direction);

		rowsSorted.forEach((row) => {
			this.refs.tableBody.appendChild(row.el);
		});
	}

	updateHeaders(currentHeader, currentDirection) {
		this.resetHeaders();

		currentHeader.dataset.direction = currentDirection;
		currentHeader.classList.add('is-sorted');
		currentHeader.classList.add(`is-sorted-${currentDirection}`);
	}

	resetHeaders() {
		this.sortHeaders
			.forEach((h) => {
				h.removeAttribute('data-direction');
				h.classList.remove('is-sorted');
				h.classList.remove('is-sorted-asc');
				h.classList.remove('is-sorted-desc');
			});
	}

	async changeUnderlyings(section) {
		this.isLoading = true;

		let tableBodyHTML;

		try {
			tableBodyHTML = await fetch(`${pathname}?section=${section}`, {
				credentials: 'same-origin',
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'content-type': 'text/html',
				},

			}).then(res => res.text());
		} catch (e) {
			console.warn('Error fetching underlyings section', e);
		} finally {
			this.isLoading = false;
		}

		this.updateTable(tableBodyHTML);
	}

	updateTable(bodyHTML) {
		this.resetHeaders();

		tickerObserver.removeTickers(this.refs.tableBody);

		this.refs.tableBody.innerHTML = bodyHTML;

		tickerObserver.addTickers(this.refs.tableBody);
	}
}

export default UnderlyingTable;
